import axios from "axios";
import config from "src/config";

const URLACTIVATEUSER = config.url.URLACTIVATEUSER;

export const ActivationAPI = {
  async activateUser(contextData, usersData, processId) {
    try {
      const headers = {
            'Content-Type': 'application/json',
            'customer': contextData.clientId,
            'session-id': contextData.sessionId,
            'sso': contextData.cookie
          }
      const response = await axios.post(`${URLACTIVATEUSER}/${processId}`, usersData, { headers });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  }
};
